import React, { useState } from 'react';
import { Phone, Mail, Mic, BriefcaseIcon, Clock, BarChart2Icon, DollarSignIcon, MoreVerticalIcon } from 'lucide-react';
interface AIRecruiterProps {
  recruiter: {
    id: number;
    name: string;
    avatar: string;
    email: string;
    phone: string;
    voice: string;
    personality: string[];
    industry: string;
    stats: {
      scheduled: number;
      completed: number;
      minutes: number;
      avgTime: number;
      successRate: number;
      cost: {
        monthly: number;
        perInterview: number;
        total: number;
      };
    };
  };
}
export const AIRecruiterCard = ({
  recruiter
}: AIRecruiterProps) => {
  const [activeTab, setActiveTab] = useState('overview');
  const [menuOpen, setMenuOpen] = useState(false);
  return <div className="bg-white rounded-lg shadow-sm border border-gray-200 overflow-hidden" data-id="element-38">
      <div className="p-4 border-b border-gray-200" data-id="element-39">
        <div className="flex justify-between" data-id="element-40">
          <div className="flex items-center" data-id="element-41">
            <div className="h-12 w-12 rounded-full bg-indigo-600 flex items-center justify-center text-white font-medium text-lg" data-id="element-42">
              {recruiter.avatar}
            </div>
            <div className="ml-3" data-id="element-43">
              <h3 className="font-medium text-lg" data-id="element-44">{recruiter.name}</h3>
              <p className="text-sm text-gray-500" data-id="element-45">
                {recruiter.industry} Specialist
              </p>
            </div>
          </div>
          <div className="relative" data-id="element-46">
            <button onClick={() => setMenuOpen(!menuOpen)} className="p-1 rounded-full hover:bg-gray-100" data-id="element-47">
              <MoreVerticalIcon size={18} className="text-gray-500" data-id="element-48" />
            </button>
            {menuOpen && <div className="absolute right-0 mt-1 w-48 bg-white rounded-md shadow-lg z-10 border border-gray-200" data-id="element-49">
                <div className="py-1" data-id="element-50">
                  <button className="block w-full text-left px-4 py-2 text-sm text-gray-700 hover:bg-gray-100" data-id="element-51">
                    Edit Profile
                  </button>
                  <button className="block w-full text-left px-4 py-2 text-sm text-gray-700 hover:bg-gray-100" data-id="element-52">
                    View Analytics
                  </button>
                  <button className="block w-full text-left px-4 py-2 text-sm text-gray-700 hover:bg-gray-100" data-id="element-53">
                    Customize Voice
                  </button>
                  <div className="border-t border-gray-100" data-id="element-54"></div>
                  <button className="block w-full text-left px-4 py-2 text-sm text-red-600 hover:bg-gray-100" data-id="element-55">
                    Deactivate
                  </button>
                </div>
              </div>}
          </div>
        </div>
        <div className="flex mt-4 border-b border-gray-200" data-id="element-56">
          <button className={`pb-2 px-4 text-sm font-medium ${activeTab === 'overview' ? 'text-indigo-600 border-b-2 border-indigo-600' : 'text-gray-500 hover:text-gray-700'}`} onClick={() => setActiveTab('overview')} data-id="element-57">
            Overview
          </button>
          <button className={`pb-2 px-4 text-sm font-medium ${activeTab === 'stats' ? 'text-indigo-600 border-b-2 border-indigo-600' : 'text-gray-500 hover:text-gray-700'}`} onClick={() => setActiveTab('stats')} data-id="element-58">
            Stats
          </button>
          <button className={`pb-2 px-4 text-sm font-medium ${activeTab === 'cost' ? 'text-indigo-600 border-b-2 border-indigo-600' : 'text-gray-500 hover:text-gray-700'}`} onClick={() => setActiveTab('cost')} data-id="element-59">
            Cost
          </button>
        </div>
      </div>
      <div className="p-4" data-id="element-60">
        {activeTab === 'overview' && <div className="space-y-3" data-id="element-61">
            <div className="flex items-center text-sm" data-id="element-62">
              <Mail size={16} className="text-gray-400 mr-2" data-id="element-63" />
              <span data-id="element-64">{recruiter.email}</span>
            </div>
            <div className="flex items-center text-sm" data-id="element-65">
              <Phone size={16} className="text-gray-400 mr-2" data-id="element-66" />
              <span data-id="element-67">{recruiter.phone}</span>
            </div>
            <div className="flex items-center text-sm" data-id="element-68">
              <Mic size={16} className="text-gray-400 mr-2" data-id="element-69" />
              <span data-id="element-70">{recruiter.voice}</span>
            </div>
            <div className="flex items-center text-sm" data-id="element-71">
              <BriefcaseIcon size={16} className="text-gray-400 mr-2" data-id="element-72" />
              <span data-id="element-73">{recruiter.industry}</span>
            </div>
            <div data-id="element-74">
              <div className="text-sm text-gray-500 mb-1" data-id="element-75">Personality</div>
              <div className="flex flex-wrap gap-1" data-id="element-76">
                {recruiter.personality.map((trait, index) => <span key={index} className="px-2 py-1 bg-indigo-50 text-indigo-700 rounded text-xs" data-id="element-77">
                    {trait}
                  </span>)}
              </div>
            </div>
          </div>}
        {activeTab === 'stats' && <div className="space-y-4" data-id="element-78">
            <div className="grid grid-cols-2 gap-3" data-id="element-79">
              <div className="bg-gray-50 p-3 rounded" data-id="element-80">
                <div className="text-xs text-gray-500" data-id="element-81">
                  Interviews Scheduled
                </div>
                <div className="text-lg font-medium" data-id="element-82">
                  {recruiter.stats.scheduled}
                </div>
              </div>
              <div className="bg-gray-50 p-3 rounded" data-id="element-83">
                <div className="text-xs text-gray-500" data-id="element-84">
                  Interviews Completed
                </div>
                <div className="text-lg font-medium" data-id="element-85">
                  {recruiter.stats.completed}
                </div>
              </div>
            </div>
            <div data-id="element-86">
              <div className="flex justify-between mb-1" data-id="element-87">
                <div className="text-xs text-gray-500" data-id="element-88">
                  Pre-Screen Success Rate
                </div>
                <div className="text-xs font-medium" data-id="element-89">
                  {recruiter.stats.successRate}%
                </div>
              </div>
              <div className="w-full bg-gray-200 rounded-full h-2" data-id="element-90">
                <div className="bg-green-500 h-2 rounded-full" style={{
              width: `${recruiter.stats.successRate}%`
            }} data-id="element-91"></div>
              </div>
            </div>
            <div className="flex items-center justify-between text-sm" data-id="element-92">
              <div className="flex items-center" data-id="element-93">
                <Clock size={16} className="text-gray-400 mr-1" data-id="element-94" />
                <span data-id="element-95">Total Speaking Time</span>
              </div>
              <span className="font-medium" data-id="element-96">
                {recruiter.stats.minutes} mins
              </span>
            </div>
            <div className="flex items-center justify-between text-sm" data-id="element-97">
              <div className="flex items-center" data-id="element-98">
                <BarChart2Icon size={16} className="text-gray-400 mr-1" data-id="element-99" />
                <span data-id="element-100">Avg. Interview Length</span>
              </div>
              <span className="font-medium" data-id="element-101">
                {recruiter.stats.avgTime} mins
              </span>
            </div>
          </div>}
        {activeTab === 'cost' && <div className="space-y-4" data-id="element-102">
            <div className="bg-indigo-50 p-3 rounded-lg" data-id="element-103">
              <div className="flex items-center text-indigo-800" data-id="element-104">
                <DollarSignIcon size={18} className="mr-1" data-id="element-105" />
                <span className="font-medium" data-id="element-106">Cost Summary</span>
              </div>
              <div className="text-2xl font-bold mt-1" data-id="element-107">
                ${recruiter.stats.cost.total}
              </div>
              <div className="text-xs text-gray-600" data-id="element-108">Total cost to date</div>
            </div>
            <div data-id="element-109">
              <div className="flex items-center justify-between text-sm mb-2" data-id="element-110">
                <span className="text-gray-600" data-id="element-111">Monthly Subscription</span>
                <span className="font-medium" data-id="element-112">
                  ${recruiter.stats.cost.monthly}
                </span>
              </div>
              <div className="flex items-center justify-between text-sm" data-id="element-113">
                <span className="text-gray-600" data-id="element-114">Cost per Interview</span>
                <span className="font-medium" data-id="element-115">
                  ${recruiter.stats.cost.perInterview.toFixed(2)}
                </span>
              </div>
            </div>
            <div className="border-t border-gray-200 pt-3 mt-3" data-id="element-116">
              <div className="text-sm text-gray-600 mb-2" data-id="element-117">Cost Efficiency</div>
              <div className="flex items-center" data-id="element-118">
                <div className="w-full bg-gray-200 rounded-full h-2 mr-2" data-id="element-119">
                  <div className="bg-indigo-600 h-2 rounded-full" style={{
                width: '75%'
              }} data-id="element-120"></div>
                </div>
                <span className="text-xs font-medium" data-id="element-121">75%</span>
              </div>
              <div className="text-xs text-gray-500 mt-1" data-id="element-122">
                25% more efficient than human recruiters
              </div>
            </div>
          </div>}
      </div>
      <div className="bg-gray-50 p-3 border-t border-gray-200" data-id="element-123">
        <div className="flex justify-between items-center" data-id="element-124">
          <span className="text-sm font-medium text-gray-700" data-id="element-125">
            Status: <span className="text-green-600" data-id="element-126">Active</span>
          </span>
          <button className="text-sm text-indigo-600 hover:text-indigo-800" data-id="element-127">
            View Details
          </button>
        </div>
      </div>
    </div>;
};